import {
  EventUserNotificationType,
  PARTICIPANT_MOVE_BUFFER_TIME,
} from "modules/userForceMove/constants";
import throttle from "modules/throttle";
import { updateEventUserNotification } from "services/firebaseService/eventUserNotifications";

export const useDelayUserForceMove = () => {
  const moveParticipantDelay = throttle(
    () => {
      updateEventUserNotification({
        type: EventUserNotificationType.EXECUTE_DELAY_MOVE,
      });
    },
    PARTICIPANT_MOVE_BUFFER_TIME,
    { leading: false },
  );

  return { moveParticipantDelay };
};
